import { Outlet, Navigate } from "react-router-dom";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { PaymentTestModeBanner } from "./PaymentTestModeBanner";
import { SubscriptionStatusBanner } from "./SubscriptionStatusBanner";
import { useAuth } from "@/contexts/AuthContext";

export default function AppLayout() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background flex-col">
        <PaymentTestModeBanner />
        <SubscriptionStatusBanner />
      <div className="flex flex-1 w-full">
        <AppSidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <header className="h-14 flex items-center gap-3 border-b bg-card/60 backdrop-blur px-3 sticky top-0 z-30">
            <SidebarTrigger />
            <div className="text-sm font-medium text-muted-foreground">
              Enterprise Business Suite
            </div>
            <div className="ml-auto text-xs text-muted-foreground hidden sm:block">
              {new Date().toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" })}
            </div>
          </header>
          <main className="flex-1 overflow-x-hidden">
            <Outlet />
          </main>
        </div>
      </div>
      </div>
    </SidebarProvider>
  );
}
